import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJMobileFaceSwapFirst.module.less';
import UploadIcon from '../../../assets/svg/mobile-upload.svg?react';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';
import UploadBorderHoverIcon from '../../../assets/svg/gradient-border.svg?react';
import GradientStarIcon from '../../../assets/svg/gradient-star.svg?react';
import faceSwapUploadBase64 from '../../../assets/base64/face-swap-upload';

import PropTypes from 'prop-types';
import FJMobileFaceSwapPresetContainer from '../FJMobileFaceSwapPreset/FJMobileFaceSwapPresetContainer';

const FJMobileFaceSwapFirst = props => {
    const { onUploadOriginImage, active } = props;
    return (
        <div className={styles.container} style={{ display: active ? 'block' : 'none' }}>
            <div className={styles.title_box}>
                <div className={styles.title}>{FJLocalStore._('ai-face-swap')}</div>
                <GradientStarIcon />
            </div>
            <div className={styles.upload_box}>
                <img className={styles.upload_img} src={faceSwapUploadBase64} />
                <div className={styles.upload_title}>{FJLocalStore._('upload-original-image')}</div>
                <FJFileUpload className={styles.upload_btn_box} onUpload={onUploadOriginImage}>
                    <FJIconButton
                        className={styles.btn}
                        icon={<UploadIcon />}
                        type={'gradient'}
                        text={FJLocalStore._('upload')}
                        textClassName={styles.btn_text}
                    />
                </FJFileUpload>
                <UploadBorderHoverIcon className={styles.upload_border} />
            </div>
            <FJMobileFaceSwapPresetContainer />
        </div>
    );
};

FJMobileFaceSwapFirst.propTypes = {
    active: PropTypes.bool,
    onUploadOriginImage: PropTypes.func,
};
export default FJMobileFaceSwapFirst;
